import { useRefreshPoints } from '@/src/common/hooks/usePoints'
import * as Stores from '../stores'

export function useRedeemPointsForStatementCredit() {
  const [redeem] =
    Stores.PointsForStatementCreditApi.endpoints[
      'POST /card/credit/:cardAccountId/redeem-points'
    ].useMutation()
  const refreshPoints = useRefreshPoints()

  const redeemPointsForStatementCredit = async ({
    cardAccountId,
    numberOfPoints,
    idempotencyKey,
  }: {
    cardAccountId: (typeof Stores.PointsForStatementCreditApi.endpoints)['GET /card/accounts/:cardAccountId']['Types']['QueryArg']['params']['cardAccountId']
    numberOfPoints: number
    idempotencyKey: string
  }) => {
    const result = await redeem({
      params: {
        cardAccountId: cardAccountId,
      },
      body: {
        numberOfPoints,
        idempotencyKey,
      },
    })

    void refreshPoints()

    return Boolean(!result.error && result.data?.id)
  }

  return {
    redeemPointsForStatementCredit,
  }
}
